export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-[#4A7C2C] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/c7e9a960a8d98f6675d66fd16b902a96/d6911449641f81f9a11579f3e218d085.png" 
              alt="Greener Eco Landscaping LLC" 
              className="h-20 sm:h-24 md:h-28 lg:h-32 w-auto mb-4 object-contain"
            />
            <p className="text-white/80 mb-6 leading-relaxed">
              Your Trusted Landscaping Partner in Owings Mills, MD
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('gallery')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Gallery
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  About
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Contact Info</h3>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:+14433980720"
                  className="flex items-center gap-3 text-white hover:text-white/80 transition-colors text-lg font-semibold cursor-pointer"
                >
                  <i className="ri-phone-fill text-xl"></i>
                  443-398-0720
                </a>
              </li>
              <li>
                <a 
                  href="mailto:greenerecolandscaping@gmail.com"
                  className="flex items-center gap-3 text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-mail-line text-lg"></i>
                  greenerecolandscaping@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/80">
                <i className="ri-map-pin-line text-lg mt-1"></i>
                <span>Owings Mills, Maryland</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm text-center md:text-left">
              © 2025 Greener Eco Landscaping LLC. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <span className="text-white/60 text-sm">Owings Mills, Maryland</span>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
